import { Injectable } from '@angular/core';
import { RegistrationModel } from '../models/registration.model';
import { IncidentServiceBase } from '../services/incident-base.service';

@Injectable()
export class TnRIncidentService extends IncidentServiceBase<RegistrationModel> {
    constructor() {
        super('TnR', () => new RegistrationModel());
    }
}
